/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import { rectSortingStrategy } from '@dnd-kit/sortable';
import Grid from '@material-ui/core/Grid';
import IconButton from '../IconButton';
import SortableList from '../SortableList';
import OptionModal from '../OptionModal';
import CardItem from '../CardItem';
import { styles } from './OptionList.styles';
import * as actions from '../../actions/index';
import {
  handleOpenModal,
  showDeleteOptionModal,
  closeModal,
  handleDragOption,
  handleStartDrag,
  handleDuplicateOption,
  handleRemoveOption
} from './OptionList.services';
import { UNIT, INGREDIENT } from '../../constants';
import { returnCategories } from '../../utils/product';
import { checkAccess } from '../../utils/admins';
import ShopModal from '../../components/ShopModal';
import { handleSynchronisationToggle } from '../../utils/shopUtils';
import { checkIntegrationAccess, getSplashType } from 'src/utils/externalIntegration';
const INITIAL_STATE = {
  isLoading: false,
  createOption: false,
  isSorting: false,
  showOptionModal: false,
  activeId: null,
  showModal: false
};
class OptionList extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  renderOptionItem = (optionKey, handleProps) => {
    const { classes, sections, categories, options } = this.props;
    const { isSorting } = this.state;
    const option = options[optionKey];
    if (option) {
      const { productKey = '' } = option;
      const mappedProducts = [];
      _.map(sections, section => {
        _.map(section.products, elt => {
          mappedProducts.push({ ...elt });
        });
      });
      const attachedproduct = mappedProducts.find(produit => produit.key === productKey);
      const categoriesArray = returnCategories(option?.subcategories, categories);
      return (
        <div {...handleProps}>
          <CardItem
            key={optionKey.toString()}
            item={option}
            className={[classes.paper, classes.maxPaper]}
            onClick={() =>
              !isSorting &&
              checkAccess('features', 'productAndOption') &&
              handleOpenModal(option, this)
            }
            onRemove={() => { showDeleteOptionModal(option, this); this.setState({ synchronize: false }) }}
            onDuplicate={() => handleDuplicateOption(option, this)}
            body={
              <div className={classes.body}>
                <p className='truncText m-0' style={{ fontSize: UNIT * 0.75, color: '#646777' }}>
                  {`Produit associé: ${(attachedproduct && attachedproduct.name) || '--'}`}
                </p>
                <p className='truncText m-0' style={{ fontSize: UNIT * 0.75, color: '#646777' }}>
                  {`Sous liste d’options:
                  ${(categoriesArray.length > 0 &&
                      categoriesArray.map(category => {
                        const { name } = category;
                        return ` ${name}`;
                      })) ||
                    '--'}`}
                </p>

              </div>
            }
            hideSuppression={_.size(options) < 2}
          />
        </div>
      );
    }
  };
  renderShops = (classes, shopId) => {
    const { showModal, selectedShops = {}, isLoading, option } = this.state;
    return (
      <ShopModal
        classes={classes}
        shopId={shopId}
        showModal={showModal}
        selectedShops={selectedShops}
        loading={isLoading}
        onClick={() => handleRemoveOption(option, this)}
        handleToggle={handleSynchronisationToggle}
        component={this}
        text={'Sélectionnez les magasins dont vous voulez supprimer cette option:'}
        title={'Supprimer votre option:'}
        isSuppression={true}
      />
    );
  };

  render() {
    const { classes, categoryKey, categories, options = {}, shopId } = this.props;
    const { option, showOptionModal, createOption, activeId, showModal } = this.state;
    const sortedOptions = _.keys(options)
      .sort((a, b) => options[a].position - options[b].position)
      .reduce((obj, cur) => ({ ...obj, [cur]: options[cur] }), {});
    const isIngType = getSplashType(categories[categoryKey].type, shopId) === INGREDIENT
    const disabled = checkIntegrationAccess('option', 'hideCreateOption')
    return (
      <div>
        <Grid container className={classes.container}>
          <div
            aria-hidden='true'
            role='button'
            onClick={() =>
              (checkAccess('features', 'productAndOption') && !disabled && handleOpenModal(option, this))
            }
            className={classes.firstItem}
          >
            <IconButton
              className={classes.addIcon}
              title='Ajouter une option'
              disabled={!checkAccess('features', 'productAndOption') || disabled}
            >
              <AddIcon className={classes.iconStyle} />
            </IconButton>
          </div>
          <SortableList
            list={sortedOptions}
            activeId={activeId}
            strategy={rectSortingStrategy}
            handleDragEnd={e => handleDragOption(e, sortedOptions, this)}
            handleDragStart={e => handleStartDrag(e, this)}
            renderItem={(optionKey, handleProps) => this.renderOptionItem(optionKey, handleProps)}
            handleDragMove={() => { }}
          />
          {showOptionModal && (
            <OptionModal
              createOption={createOption}
              isOpen={showOptionModal}
              category={categories[categoryKey]}
              option={option}
              closeModal={() => closeModal(this)}
            />
          )}
          {showModal && this.renderShops(classes, shopId)}
        </Grid>
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, user }) {
  const { shops = {}, menu = {} } = firebaseRealTime;
  const { nbShops, shopId } = user
  const { categories = {}, sections = {} } = menu;
  return {
    categories,
    sections,
    shops,
    shopId,
    nbShops
  };
}
OptionList.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(OptionList));
